import { HRISProviderSlugEnum } from '@electricjs/core_entity-client';

/**
 * Maps Auth0 external connection names (from external_connection_name claim)
 * to HRIS provider slugs used for embedded first-login signup.
 * If the connection name is not in this map, the embedded first-login flow
 * shows InitFailedState.
 */
export const EXTERNAL_CONNECTION_NAME_TO_HRIS_PROVIDER: Record<
  string,
  HRISProviderSlugEnum
> = {
  'trinet-peo': HRISProviderSlugEnum.TrinetPeodirect,
  isolved: HRISProviderSlugEnum.Isolved,
  justworks: HRISProviderSlugEnum.Justworksdirect,
  paychex: HRISProviderSlugEnum.Paychex,
};

export const getHrisProviderForConnectionName = (
  connectionName: string
): HRISProviderSlugEnum | undefined =>
  EXTERNAL_CONNECTION_NAME_TO_HRIS_PROVIDER[connectionName];

/**
 * Connections where the 3rd-party platform embeds custom claims that identify
 * the user's organization. Because a user can belong to multiple orgs, each
 * login must be fresh — Auth0's cached session must not be reused in iframes.
 */
const EMBEDDED_MULTI_TENANT_LOGIN_CONNECTIONS = new Set([
  'trinet-peo',
  'justworks',
]);

export const connectionHasEmbeddedMultiTenantLogin = (
  connectionName: string | null | undefined
): boolean =>
  !!connectionName &&
  EMBEDDED_MULTI_TENANT_LOGIN_CONNECTIONS.has(connectionName);
